import { buildParams } from '@/helpers/url';
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-throw-literal */
/* eslint-disable camelcase */
const initialState = {
  permissionsSettings: null,
  roles: null,
  answerTypes: [
    { slug: 'free-text', name: 'Free text' },
    { slug: 'yes-no', name: 'Yes or no' },
    { slug: 'rating', name: 'Rating' },
    { slug: 'percent', name: 'Percentage' },
    { slug: 'point', name: 'Point', is_hidden: true }, // don't change the order of this array!!! used in SET_IS_POINT_TEMPLATE
    { slug: 'custom', name: 'Custom' },
  ],
  calculateTypes: [
    { slug: 'non-weight', name: 'Non weight' },
    { slug: 'weight', name: 'Weight' },
  ],
  rolesPaginated: {
    data: [],
    meta: {},
  },
  templates: {
    data: [],
    meta: {},
  },
  template: {},
  assignedRoles: {
    data: [],
    meta: {},
  },
  nineBoxColorBlocks: {
    5: {
      block_1: ['#F9D4B8', '#E0ECC5', '#C7EBDD', '#96D9BF', '#69C9A4'],
      block_2: ['#F6C2BC', '#F9D4B8', '#E0ECC5', '#C7EBDD', '#96D9BF'],
      block_3: ['#F3A5AB', '#F6C2BC', '#F9D4B8', '#E0ECC5', '#C7EBDD'],
      block_4: ['#EF858E', '#F3A5AB', '#F6C2BC', '#F9D4B8', '#E0ECC5'],
      block_5: ['#EA616D', '#EF858E', '#F3A5AB', '#F6C2BC', '#F9D4B8'],
    },
    4: {
      block_2: ['#F9D4B8', '#E0ECC5', '#C7EBDD', '#96D9BF', '#69C9A4'],
      block_3: ['#F6C2BC', '#F9D4B8', '#E0ECC5', '#C7EBDD', '#96D9BF'],
      block_4: ['#F3A5AB', '#F6C2BC', '#F9D4B8', '#E0ECC5', '#C7EBDD'],
      block_5: ['#EF858E', '#F3A5AB', '#F6C2BC', '#F9D4B8', '#E0ECC5'],
    },
    3: {
      block_3: ['#F9D4B8', '#E0ECC5', '#C7EBDD', '#96D9BF', '#69C9A4'],
      block_4: ['#F6C2BC', '#F9D4B8', '#E0ECC5', '#C7EBDD', '#96D9BF'],
      block_5: ['#F3A5AB', '#F6C2BC', '#F9D4B8', '#E0ECC5', '#C7EBDD'],
    },
  },
};

const mutations = {
  SET_PERMISSIONS(state, payload) {
    state.permissionsSettings = payload;
  },
  SET_ROLES(state, payload) {
    state.roles = payload;
  },
  setRolesPaginatedData(state, payload) {
    state.rolesPaginated.data = payload;
  },
  setRolesPaginatedMeta(state, payload) {
    state.rolesPaginated.meta = { ...payload };
    if (state.rolesPaginated.meta.data) {
      delete state.rolesPaginated.meta.data;
    }
  },
  SET_IS_POINT_TEMPLATE(state, payload) {
    state.answerTypes[4].is_hidden = !payload;
  },
  SET_TEMPLATE(state, payload) {
    state.template = payload?.contents;
  },
  setAssignedRolesData(state, payload) {
    state.assignedRoles.data = payload;
  },
  setAssignedRolesMeta(state, payload) {
    state.assignedRoles.meta = { ...payload };
    if (state.assignedRoles.meta.data) {
      delete state.assignedRoles.meta.data;
    }
  },
};

const getters = {
  // Types option for indicators with answer_type = custom
  getCustomTypes(state) {
    return state.answerTypes.filter(item => item.slug !== 'custom' && item.slug !== 'point');
  },
  rolesPaginated(state) {
    return state.rolesPaginated.data;
  },
  rolesPaginatedMeta(state) {
    return state.rolesPaginated.meta;
  },
  template(state) {
    return state.template;
  },
  assignedRoles(state) {
    return state.assignedRoles.data;
  },
  assignedRolesMeta(state) {
    return state.assignedRoles.meta;
  },
};

const actions = {
  async getTemplates(context, { metas, keyword }) {
    const params = {
      page: metas.current_page,
      limit_per_page: metas.per_page,
      template_name: keyword,
    };
    const url = `${this._vm.$newEndPoint}/review-templates?${buildParams(params)}`;

    try {
      const { response, data } = await this._vm.$axios.get(url);

      if (data?.status_code === 200) {
        return data.contents;
      }

      throw Error(response?.data?.message || data?.message || 'Failed to fetch template data');
    } catch (err) {
      if (err instanceof TypeError) throw Error('Failed to fetch template data');

      throw Error(err);
    }
  },
  async getPresets() {
    try {
      const { data, response } = await this._vm.$axios.get(`${this._vm.$newEndPoint}/review-templates/presets`);

      if ((data?.status === 200 || data?.status_code === 200) && data?.contents) {
        return data;
      }

      throw response?.data?.message || data?.message || 'Failed to fetch presets list';
    } catch (err) {
      throw Error(err);
    }
  },
  async deleteTemplate(context, id) {
    const url = `${this._vm.$endPoint}/review-templates/${id}`;

    try {
      if (!id) throw Error('Invalid template ID');

      const res = await this._vm.$axios.delete(url);

      if (res.data?.status_code === 200) {
        return res.data.contents;
      }

      throw Error(res.response?.data?.message || 'Failed to delete template');
    } catch (err) {
      throw Error(err);
    }
  },
  async detailTemplate(context, uuid) {
    const url = `${this._vm.$endPoint}/review-templates/detail/${uuid}`;

    try {
      if (!uuid) throw Error('Invalid template UUID');

      const res = await this._vm.$axios.get(url);

      if (res.data?.status_code === 200) {
        return res.data.contents;
      }

      throw Error(res.response?.data?.message || 'Failed to view template');
    } catch (err) {
      throw Error(err);
    }
  },
  async updateStatusTemplate(context, { uuid, val }) {
    const url = `${this._vm.$endPoint}/review-templates/update-status/${uuid}`;

    try {
      const res = await this._vm.$axios.put(url, { status: val });

      return res;
    } catch (err) {
      if (err instanceof TypeError) throw Error('Failed to change template status');

      throw Error(err);
    }
  },
  async getUserRoles() {
    const path = `${this._vm.$endPoint}/role-users`;

    try {
      const { data, response } = await this._vm.$axios.get(path);

      if ((data?.status === 200 || data?.status_code === 200) && data?.contents) {
        const result = data.contents.role_users.map(item => {
          return {
            ...item,
            fullName: `${item.user.first_name} ${item.user.last_name}`,
            roleName: item.role?.name || '-',
          };
        });

        return result;
      }

      throw response.data.message;
    } catch (err) {
      if (err instanceof TypeError) throw Error('Failed to fetch roles');

      throw Error(err);
    }
  },
  async deleteAssignRole(context, id) {
    const path = `${this._vm.$endPoint}/role-users/${id}`;

    try {
      const { data, response } = await this._vm.$axios.delete(path);

      if ((data?.status === 200 || data?.status_code === 200) && data?.contents) {
        return data.contents;
      }

      throw response.data.message;
    } catch (err) {
      throw Error(err);
    }
  },
  async updateAssignRole(context, { roleId, userId }) {
    const path = `${this._vm.$endPoint}/role-users`;

    try {
      const { data, statusMessage } = await this._vm.$axios.put(path, { role_id: roleId, user_id: userId });

      if ((data?.status === 200 || data?.status_code === 200) && data?.contents) {
        return data.contents;
      }

      throw statusMessage || data?.message;
    } catch (err) {
      throw Error(err);
    }
  },
  async getRoles() {
    const path = `${this._vm.$endPoint}/roles`;

    try {
      const { data, response } = await this._vm.$axios.get(path);

      if ((data?.status === 200 || data?.status_code === 200) && data?.contents) {
        return data.contents.roles;
      }

      throw response.data.message;
    } catch (err) {
      throw Error(err);
    }
  },
  async fetchPermissions({ commit }) {
    const path = `${this._vm.$endPoint}/permissions`;

    try {
      const { data, response } = await this._vm.$axios.get(path);

      if ((data?.status === 200 || data?.status_code === 200) && data?.contents) {
        commit('SET_PERMISSIONS', [...data.contents.permissions]);
      } else {
        commit('SET_PERMISSIONS', []);
        throw response.data.message;
      }
    } catch (err) {
      throw Error(err);
    }
  },
  async createRole(context, payload) {
    const path = `${this._vm.$endPoint}/roles`;

    try {
      const res = await this._vm.$axios.post(path, payload);

      if (res.response?.data) {
        const { data } = res.response;
        let errMessage = '';

        // iterate all errors message, as some error response json have { errors: [...] } attribute
        if (typeof data.errors === 'object') {
          Object.keys(data.errors).forEach(key => {
            if (key) {
              errMessage += `${key}: ${data.errors[key]}\n`;
            }
          });
        } else errMessage = data.message.substring(0, 255);

        throw errMessage;
      } else {
        const { data, statusMessage } = res;

        if ((data?.status === 200 || data?.status_code === 200) && data?.contents) {
          return data.contents.role;
        }

        throw statusMessage || data.message;
      }
    } catch (err) {
      throw Error(err);
    }
  },
  async fetchRole(context, payload) {
    const path = `${this._vm.$endPoint}/roles/${payload}`;

    try {
      const { data, response } = await this._vm.$axios.get(path);

      if ((data?.status === 200 || data?.status_code === 200) && data?.contents) {
        return data.contents.role;
      }

      throw response?.data?.message;
    } catch (err) {
      throw Error(err);
    }
  },
  async updateRole(context, payload) {
    const path = `${this._vm.$endPoint}/roles/${payload.role_id}`;

    try {
      const res = await this._vm.$axios.put(path, payload);

      if (res.response?.data) {
        const { data } = res.response;
        let errMessage = '';

        // iterate all errors message
        if (typeof data.errors === 'object') {
          Object.keys(data.errors).forEach(key => {
            if (key) {
              errMessage += `${key}: ${data.errors[key]}\n`;
            }
          });
        } else errMessage = data.message.substring(0, 255);

        throw errMessage;
      } else {
        const { data, statusMessage } = res;

        if ((data?.status === 200 || data?.status_code === 200) && data?.contents) {
          return data.contents;
        }

        throw statusMessage || data.message;
      }
    } catch (err) {
      throw Error(err);
    }
  },
  async deleteRole(context, payload) {
    try {
      const url = `${this._vm.$endPoint}/roles/${payload}`;
      const { data, response } = await this._vm.$axios.delete(url);

      if (data?.status_code === 200) {
        return data.contents;
      }
      throw response.data.message || 'Failed to delete role';
    } catch (err) {
      throw Error(err);
    }
  },
  async getAndStoreRoles({ commit, dispatch }) {
    const roles = await dispatch('getRoles');

    commit('SET_ROLES', roles);
  },
  async submitAssignRole(context, payload) {
    try {
      const url = `${this._vm.$newEndPoint}/role-users`;
      const { data, response } = await this._vm.$axios.post(url, payload);

      if (data?.status_code === 200) return data.contents;

      throw { message: response?.data?.message, data: response?.data?.data };
    } catch (err) {
      throw err || { message: 'Failed to assign roles' };
    }
  },
  async createUpdateTemplate(context, payload) {
    try {
      const url = `${this._vm.$endPoint}/review-templates`;

      const { data, response } = await this._vm.$axios.post(url, payload);

      if (data?.status_code === 200) {
        return data.contents || '';
      }

      // eslint-disable-next-line no-throw-literal
      throw response?.data;
    } catch (err) {
      // eslint-disable-next-line no-throw-literal
      throw err || { message: 'Failed to create template' };
    }
  },
  async getTemplate(context, uuid) {
    try {
      const url = `${this._vm.$endPoint}/review-templates/detail/${uuid}`;
      const { data, response } = await this._vm.$axios.get(url);

      context.commit('SET_TEMPLATE', data);

      if (data?.status_code === 200) {
        return data.contents;
      }

      throw response?.data || data;
    } catch (err) {
      throw err || { message: 'Failed to fetch template' };
    }
  },
  async getAssignedRoles(context, payload) {
    try {
      const url = `${this._vm.$endPoint}/role-users/pagination`;
      const { data, response } = await this._vm.$axios({
        method: 'get',
        url,
        params: payload.params,
      });

      if (data?.contents) {
        context.commit('setAssignedRolesData', data?.contents?.data || []);
        context.commit('setAssignedRolesMeta', data?.contents || {});
      } else throw response?.data?.message || data?.message;
    } catch (err) {
      throw err || { message: 'Failed to fetch roles' };
    }
  },
  async getRolesPaginated(context, payload) {
    try {
      const url = `${this._vm.$endPoint}/roles/roles-pagination`;
      const { data, response } = await this._vm.$axios({
        method: 'get',
        url,
        params: payload.params,
      });

      if (data?.status_code === 200) {
        context.commit('setRolesPaginatedData', data?.contents?.roles?.data || []);
        context.commit('setRolesPaginatedMeta', data?.contents?.roles || {});
      } else {
        throw response?.data;
      }
    } catch (err) {
      throw err || { message: 'Failed to fetch roles' };
    }
  },
};

export default {
  namespaced: true,
  state: () => ({ ...initialState }),
  mutations,
  getters,
  actions,
};

/* eslint-enable no-underscore-dangle */
/* eslint-enable no-throw-literal */
